// Этот файл генерируется автоматически, его не следует редактировать вручную
import menuButton from '@/widgets/menuButton.js';
import menuPopup from '@/widgets/menuPopup.js';
import scrollAnimationTrigger from '@/widgets/scrollAnimationTrigger.js';
import scrollTop from '@/widgets/scrollTop.js';
import scroller from '@/widgets/scroller.js';
import stretchByScroll from '@/widgets/stretchByScroll.js';
import test from '@/widgets/test.js';

export default {
  'menuButton': async () => { return { default: menuButton }; },
  'menuPopup': async () => { return { default: menuPopup }; },
  'reviewsSlider': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/reviewsSlider.js'),
  'scrollAnimationTrigger': async () => { return { default: scrollAnimationTrigger }; },
  'scrollTop': async () => { return { default: scrollTop }; },
  'scroller': async () => { return { default: scroller }; },
  'storiesCarousel': async () => await import( /* webpackMode: "lazy-once" */ '@/widgets/storiesCarousel.js'),
  'stretchByScroll': async () => { return { default: stretchByScroll }; },
  'test': async () => { return { default: test }; }
};
